import React from "react";
import "./ColumnColors.scss";

const KCBStatusColors = {
  "Phiếu Khám Mới": {
    color: "",
  },
  "Chưa tới ngày hẹn": {
    color: "#9932CC",
  },
  "Chờ Thực Hiện": {
    color: "#6C757D",
  },
  "Chờ thực hiện": {
    color: "#6C757D",
  },
  "Đang Thực Hiện": {
    color: "#3755b2",
  },
  "Đang thực hiện": {
    color: "#3755b2",
  },
  "Hoàn Thành": {
    color: "#198754",
  },
  "Hoàn thành": {
    color: "#198754",
  },
  "Chờ tới ngày thực hiện": {
    color: "#198754",
  },
  "Chờ kết quả xét nghiệm": {
    color: "#FFA500",
  },
  "Đã có kết quả xét nghiệm": {
    color: "#80FFC4",
  },
  "Hủy thực hiện": {
    color: "#DC3545",
  },
  "Đã xoá": {
    color: "",
  },
  "Chờ kết quả CLS": {
    color: "#00bbff",
  },
  Hủy: {
    color: "#DC3545",
  },
};

const KCBStatusColumn = ({label}: {label: string}) => {
  return (
    <div
      className="color-column"
      style={{
        backgroundColor: KCBStatusColors[label]?.color,
        textAlign: "center",
      }}
    >
      {label == "Phiếu Khám Mới" ? "" : label}
    </div>
  );
};

export default KCBStatusColumn;
